/**
 * Color thumbnail click → gallery navigation for the per-SKU variant list.
 *
 * All product images (shared + variant) are now rendered in the gallery in
 * admin order. On color click, we find the matching slide that already exists
 * and activate it via Dawn's setActiveMedia, then scroll the mobile slider.
 */
document.addEventListener('click', (event) => {
  const button = event.target.closest('.sku-list__thumb-button');
  if (!button) return;

  event.preventDefault();

  const sectionId = button.dataset.sectionId;
  const imageSrc = button.dataset.imageSrc;
  if (!sectionId || !imageSrc) return;

  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (!sectionEl) return;

  const gallery = sectionEl.querySelector('media-gallery');
  if (!gallery) return;

  // Find the matching thumbnail by image filename to get the media ID
  const thumbnails = gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]');
  const srcFilename = extractFilename(imageSrc);
  let matchedThumb = null;

  for (const thumb of thumbnails) {
    const img = thumb.querySelector('img');
    if (!img) continue;
    if (extractFilename(img.currentSrc || img.src) === srcFilename) {
      matchedThumb = thumb;
      break;
    }
  }

  if (!matchedThumb) return;

  const fullMediaId = matchedThumb.dataset.target;
  if (!fullMediaId) return;

  // Activate the slide via Dawn's API (handles is-active + aria-current)
  if (typeof gallery.setActiveMedia === 'function') {
    gallery.setActiveMedia(fullMediaId, false);
  }

  // Scroll mobile slider to the target slide
  const sliderList = gallery.querySelector('[id^="Slider-Gallery"]');
  const slide = sliderList?.querySelector(`[data-media-id="${fullMediaId}"]`);
  if (slide) {
    slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }
});

/**
 * Extract the base filename from a Shopify CDN URL, stripping query
 * params and the _WIDTHx suffix that varies between sizes.
 * e.g. "https://cdn.shopify.com/.../image_416x.jpg?v=123" → "image.jpg"
 */
function extractFilename(url) {
  if (!url) return '';
  const path = url.split('?')[0];
  const name = path.split('/').pop();
  return name.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
}
